import { computed, inject } from '@angular/core';
import { signalStore, type, withComputed, withProps } from '@ngrx/signals';
import { entityConfig, withEntities } from '@ngrx/signals/entities';
import {
  withEntitiesLoadingCall,
  withCallStatus,
  withEntitiesLocalSort,
  withLogger,
} from '@ngrx-traits/signals';
import { PrintTemplateOption, PrintTemplateOptionService } from '..';
import { map } from 'rxjs';

const printTemplateOptionConfig = entityConfig({
  entity: type<PrintTemplateOption>(),
  collection: 'printTemplateOption',
});

export const PrintTemplateOptionStore = signalStore(
  withEntities(printTemplateOptionConfig),
  withCallStatus(printTemplateOptionConfig, {
    initialValue: 'loading',
  }),
  withEntitiesLocalSort(
    {
      entity: type<PrintTemplateOption>(),
      collection: printTemplateOptionConfig.collection,
    },
    {
      defaultSort: { field: 'name', direction: 'asc' },
    }
  ),
  withLogger({
    name: 'PrintTemplateOptionStore',
    showDiff: true,
  }),
  withProps(() => ({
    _printTemplateOptionService: inject(PrintTemplateOptionService),
  })),
  withEntitiesLoadingCall(({ _printTemplateOptionService }) => ({
    collection: printTemplateOptionConfig.collection,
    fetchEntities: () =>
      _printTemplateOptionService.loadPrintTemplates().pipe(
        map((response) => ({
          entities: response.result,
          total: response.count,
        }))
      ),
  })),
  withComputed(({ printTemplateOptionEntities }) => ({
    options: computed(() =>
      printTemplateOptionEntities().map(printTemplateOptionToOption)
    ),
  }))
);

const printTemplateOptionToOption = (printTemplate: PrintTemplateOption) => ({
  value: printTemplate.id.toString(),
  label: printTemplate.name,
  metadata: printTemplate,
});
